<script>
import { getUserView } from '../../js/readModel.js';
import { commands, queries } from '../../js/lib/functions.js'
import { navigate } from '@trullock/page-manager'
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import DateTime from '../../../functions/lib/dateTime.js'
import { showToast } from '../../js/utils/toast.js'
import { cropImage } from '../../js/utils/cropper.js';

export const pageName = 'admin-user-edit';
export const pageRoute = '/admin/user/{userId}/edit';
export const title = 'Edit User'
export const requireAdmin = true;
export const requireEmailVerified = false;

export default {
	data() {
		return { 
			user: null,
			name: '',
			email: '',
			emailComplained: false,
			emailBounced: false,
			number: 0,
			bornOn: null,
			memberSince: null,
			UKRARole: null,
			maxDob: DateTime.today,
			minDob: DateTime.today.addYears(-120),
			BMFANumber: '',
			BMFASurname: '',
			avatar: null,
			certL1: false,
			certL2: false,
			certL3: false,
			certRSO: false,
			files: [],
			vendorName: null,
			ready: false
		}
	},
	methods: {
		async show(opts)
		{
			this.user = opts.user || await getUserView(opts.userId);
			this.name = this.user.name;
			this.number = this.user.number;
			this.bornOn = this.user.bornOn?.format('yyyy-MM-dd');
			this.memberSince = this.user.createdOn.format('yyyy-MM-dd')
			this.email = this.user.email;
			this.emailBounced = this.user.emailBounced;
			this.emailComplained = this.user.emailComplained;
			this.avatar = this.user.avatar;
			this.BMFANumber = this.user.insurance.BMFANumber
			this.BMFASurname = this.user.insurance.BMFASurname
			this.UKRARole = this.user.ukra.role;
			this.vendorName = this.user.vendorName;
			this.files = []
			this.ready = true;
		},
		hide()
		{
			this.$refs.fupAvatar.value = null
			this.$refs.lblAvatar.innerHTML = "Choose image&hellip;";
		},
		async submit() {			
			showLoading();

			this.$refs.number.setCustomValidity('');
			this.$refs.bmfaNumber.setCustomValidity('');
			this.$refs.bmfaSurname.setCustomValidity('');
			this.$refs.bornOn.setCustomValidity('');

			if(this.name != this.user.name)
			{
				let result = await commands.users.account.changeName({ userId: this.user.id, name: this.name});
				if(!result.success)
				{
					showToast({ message: 'Error changing user\'s name: ' + result.error, style: 'bg-danger'})
					hideLoading();
					return;
				}
			}

			if(this.email != this.user.email)
			{
				let result = await commands.users.account.changeEmail({ userId: this.user.id, email: this.email});
				if(!result.success)
				{
					if(result.error == 'auth/email-already-exists')
					{
						this.$refs.bornOn.setCustomValidity('A user with this email address already exists');
						this.$refs.bornOn.reportValidity();
					}
					else
					{
						showToast({ message: 'Error changing user\'s email: ' + result.error, style: 'bg-danger'})
					}
					
					hideLoading();
					return;
				}
			}
			
			let bornOn = this.bornOn ? new DateTime(this.bornOn) : null
			if(bornOn && !bornOn.equals(this.user.bornOn) || this.user.bornOn && !this.user.bornOn.equals(bornOn))
			{
				let result = await commands.users.account.changeBornOn({ userId: this.user.id, bornOn});
				if(!result.success)
				{
					showToast({ message: 'Error changing user\'s DoB: ' + result.error, style: 'bg-danger'})
					hideLoading();
					return;
				}
			}

			if(this.number != this.user.number)
			{
				let result = await queries.users.account.queryNumber({
					userId: this.user.id,
					number: this.number
				})

				if(!result.status)
				{
					this.$refs.number.setCustomValidity('Already in use');
					this.$refs.number.reportValidity();

					hideLoading();
					return;
				}

				result = await commands.users.account.changeNumber({ userId: this.user.id, number: this.number});
				if(!result.success)
				{
					showToast({ message: 'Error changing user\'s number: ' + result.error, style: 'bg-danger'})
					hideLoading();
					return;
				}
			}

			if(this.emailBounced != this.user.emailBounced)
			{
				let result = await commands.users.account.setEmailBounced({ userId: this.user.id, bounced: this.emailBounced });
				if(!result.success)
				{
					showToast({ message: 'Error setting email bounce', style: 'bg-danger'})
					hideLoading();
					return;
				}
			}

			if(this.emailComplained != this.user.emailComplained)
			{
				let result = await commands.users.account.setEmailComplained({ userId: this.user.id, complained: this.emailComplained });
				if(!result.success)
				{
					showToast({ message: 'Error setting email complaint', style: 'bg-danger'})
					hideLoading();
					return;
				}
			}

			let createdOn = new DateTime(this.memberSince)
			if(!createdOn.equals(this.user.createdOn))
			{
				let result = await commands.users.account.changeCreatedOn({ userId: this.user.id, createdOn});
				if(!result.success)
				{
					showToast({ message: 'Error changing user\'s Member-Since: ' + result.error, style: 'bg-danger'})
					hideLoading();
					return;
				}
			}

			if(this.BMFANumber != this.user.insurance.BMFANumber || this.BMFASurname != this.user.insurance.BMFASurname)
			{
				let queryResult = await queries.users.account.queryBMFA({
					surname: this.BMFASurname,
					number: this.BMFANumber
				})

				// Dont apply BMFA check to admin accounts. TODO: Bit crude, do something better to allow admin accounts to be Completed with no BMFA details
				if(queryResult.success && !this.user.isAdmin)
				{
					if(queryResult.result.status == 'expired')
					{
						this.$refs.bmfaSurname.setCustomValidity(' ');
						this.$refs.bmfaSurname.reportValidity();

						this.$refs.bmfaNumber.setCustomValidity('Insurance is expired');
						this.$refs.bmfaNumber.reportValidity();

						hideLoading();
						return;
					}
					else if(queryResult.result.status == 'not-found')
					{
						this.$refs.bmfaSurname.setCustomValidity(' ');
						this.$refs.bmfaSurname.reportValidity();

						this.$refs.bmfaNumber.setCustomValidity('Insurance details not found');
						this.$refs.bmfaNumber.reportValidity();

						hideLoading();
						return;
					}
				}
				
				queryResult = await commands.users.account.changeInsurance({ userId: this.user.id, number: this.BMFANumber.toString(), surname: this.BMFASurname });
				if(!queryResult.success)
				{
					showToast({ message: 'Error changing user\'s BMFA details: ' + queryResult.error, style: 'bg-danger'})
					hideLoading();
					return;
				}

				
			}
			
			// TODO: only if changed
			let result = await commands.users.account.changeUKRA({ userId: this.user.id, role: this.UKRARole });
			if(!result.success)
			{
				showToast({ message: 'Error changing user\'s UKRA details: ' + result.error, style: 'bg-danger'})
				hideLoading();
				return;
			}

			// TODO: only if changed
			result = await commands.users.account.changeVendorStatus({ userId: this.user.id, vendorName: this.vendorName });
			if(!result.success)
			{
				showToast({ message: 'Error changing user\'s Vendor details: ' + result.error, style: 'bg-danger'})
				hideLoading();
				return;
			}

			if(this.newAvatar)
			{
				let result = await commands.users.account.changeAvatar({ userId: this.user.id, avatar64: this.newAvatar});
				if(!result.success)
				{
					showToast({ message: 'Error changing user\'s avatar: ' + result.error, style: 'bg-danger'})
					hideLoading();
					return;
				}
			}

			navigate('/admin/user/' + this.user.id)

			hideLoading();
		},
		inputChanged(e) {
			var files = e.target.files;

			if (files && files.length > 0) {
				let file = files[0];

				this.$refs.fupAvatar.value = '';
				this.$refs.fupAvatar.blobData = null;
				
				cropImage({
					aspectRatio: 1,
					viewMode: 1,
					autoCropArea: 1
				}, { 
					width: 240, 
					height: 240 
				}, file).then(canvas => {
					this.avatar = canvas.toDataURL();
					this.newAvatar = this.avatar;

					canvas.toBlob(blob => {
						this.$refs.fupAvatar.blobData = {
							blob: blob,
							name: 'avatar.jpg'
						};

						this.$refs.lblAvatar.innerText = file.name;
					});
				}, e => {
					if(e instanceof Error)
					{
						this.$refs.fupFlightCard.setCustomValidity(e.message);
						this.$refs.fupFlightCard.reportValidity();
					}
				})
			}
		}
	}
}
</script>
<template>
<div class="container" v-if="ready">
    <form @submit.prevent="submit">
		<div class="row justify-content-center py-5">
			<div class="col-12 col-md-8">
				
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Profile</h4>
					</div>
					<div class="card-body">
						<fieldset>
							<div class="form-group">
								<label>Name</label>
								<input type="text" class="form-control" v-model="name" autocomplete="off" placeholder="First Last" required />
								<span class="invalid-feedback"></span>
							</div>
							<legend>Contact Details</legend>
							<div class="form-group">
								<label>Email address</label>
								<input type="email" class="form-control" autocomplete="off" ref="bornOn" v-model="email" placeholder="e.g. user@example.com" required/>
							</div>
							<div class="form-group">
								<label>Date of birth</label>
								<input type="date" class="form-control" ref="dob" v-model="bornOn" :max="`${maxDob.format('yyyy-MM-dd')}`" :min="`${minDob.format('yyyy-MM-dd')}`"/>
								<span class="invalid-feedback"></span>
							</div>
						</fieldset>
						<hr>
						<fieldset>
							<div class="field form-group mb-0">
								<label>
									Picture
									<div class="dz-default dz-message py-5">
										<div class="avatar avatar-xxl">
											<img ref="imgAvatar" class="avatar-img rounded-circle" :src="avatar" alt="Avatar">
										</div>
									</div>
								</label>

								<div class="custom-file">
									<input type="file" @change="inputChanged" ref="fupAvatar" class="custom-file-input" accept="image/*">
									<label ref="lblAvatar" class="custom-file-label text-muted">Choose image&hellip;</label>
								</div>
								<span class="form-text text-muted small mb-0">Must be a jpeg or png</span>
							</div>
						</fieldset>
					</div>
				</div>
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Internal</h4>
					</div>
					<div class="card-body">
						<fieldset>
							<div class="form-group">
								<label>UKRA Number</label>
								<input type="number" step="1" min="1" max="99999" class="form-control" autocomplete="off" ref="number" v-model="number" placeholder="e.g. 123456" />
								<span class="invalid-feedback"></span>
							</div>
							<div class="form-group">
								<label>Member Since</label>
								<input type="date" class="form-control" v-model="memberSince" :max="`${maxDob.format('yyyy-MM-dd')}`"/>
								<span class="invalid-feedback"></span>
							</div>		
							<div class="form-group">
								<div class="custom-control custom-switch">
									<input type="checkbox" class="custom-control-input" :value="true" v-model="emailBounced">
									<label class="custom-control-label">Email Bounced</label>
								</div>
								<span class="form-text text-muted small mb-0">Enabling this will also un-email-verify the user.</span>
							</div>
							<div class="form-group">
								<div class="custom-control custom-switch">
									<input type="checkbox" class="custom-control-input" :value="true" v-model="emailComplained">
									<label class="custom-control-label">Email Complained</label>
								</div>
							</div>
						</fieldset>
					</div>
				</div>
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Insurance</h4>
					</div>
					<div class="card-body">
						<fieldset>
							<legend>Insurance details</legend>
							<div class="row">
								<div class="col">
									<div class="form-group mb-0">
										<label>BMFA Number</label>
										<input type="text" pattern="[0-9]+" class="form-control" autocomplete="off" ref="bmfaNumber" v-model="BMFANumber" placeholder="e.g. 123456" />
										<span class="invalid-feedback"></span>
									</div>
								</div>
								<div class="col">
									<div class="form-group mb-0">
										<label>Surname</label>
										<input type="text" class="form-control" autocomplete="off" ref="bmfaSurname" v-model="BMFASurname" placeholder="e.g. Smith" />
										<span class="invalid-feedback"></span>
									</div>
								</div>
							</div>
						</fieldset>
					</div>
				</div>
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">UKRA</h4>
					</div>
					<div class="card-body">
						<fieldset>
							<div class="form-group mb-0">
								<label>UKRA Role</label>
								<input type="text" class="form-control" autocomplete="off" v-model="UKRARole" placeholder="e.g. Chair" />
								<span class="invalid-feedback"></span>
							</div>
						</fieldset>
					</div>
				</div>
				
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Misc</h4>
					</div>
					<div class="card-body">
						<fieldset>
							<div class="form-group mb-0">
								<label>Vendor Name</label>
								<input type="text" class="form-control" autocomplete="off" v-model="vendorName" placeholder="e.g. Joe's Rocket Shop" />
								<span class="invalid-feedback"></span>
								<span class="form-text text-muted small mb-0">The name of the Vendor this member operates.</span>
							</div>
						</fieldset>
					</div>
				</div>
				<button type="submit" class="btn btn-lg btn-primary btn-block">Save changes <span class="fe fe-check-circle"></span></button>
			</div>
		</div>
	</form>
</div>
</template>